 
namespace TabAurous.Retail {
    import fld = POSApprovalBOMRow.Fields;
    @Serenity.Decorators.registerClass()
    export class POSApprovalBOMEditor extends _Ext.BOMGridEditor<POSApprovalBOMRow> { 
        protected getDialogType() { return POSApprovalBOMDialog; }
        protected getLocalTextPrefix() { return POSApprovalBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as POSApprovalItemsDialog).CalculateTotals();
                }
            });
        } 
        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }  
    }
}